import type { FC } from 'react';

import {
  AutoplayStopButton,
  AutoplayStopButtonProps,
} from '@pp/core/src/components/game/autoplayV2/buttons/stopButton/AutoplayStopButton';

import { Bets } from '../../../../config/bets';
import { useCrashAutoplaySlice } from '../../../../store/slices/crashAutoplay/selectors';

export interface AutoplayStopButtonConnectedProps extends Pick<AutoplayStopButtonProps, 'onClick' | 'disabled'> {
  betId: Bets;
}

export const CrashAutoplayStopButtonConnected: FC<AutoplayStopButtonConnectedProps> = ({
  betId,
  onClick,
  disabled,
}) => {
  const roundsLeft = useCrashAutoplaySlice.getRemainingCount(betId);
  const totalRounds = useCrashAutoplaySlice.getTotalRounds(betId);

  return <AutoplayStopButton count={roundsLeft} totalRounds={totalRounds} onClick={onClick} disabled={disabled} />;
};
